import { render, staticRenderFns } from "./TeacherSubjectTemplates.vue?vue&type=template&id=c1a107d6"
import script from "./TeacherSubjectTemplates.vue?vue&type=script&lang=js"
export * from "./TeacherSubjectTemplates.vue?vue&type=script&lang=js"
import style0 from "./TeacherSubjectTemplates.vue?vue&type=style&index=0&id=c1a107d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports